import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export function FormShell({ title, kicker, description, children }) {
  return (
    <div className="bg-slate-50 min-h-screen">
      <div className="bg-[#0B0F19] text-white pt-12 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 ici-grid-bg-dark opacity-40" />
        <div className="max-w-4xl mx-auto px-4 lg:px-8 relative">
          {kicker && <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#0055FF]">{kicker}</div>}
          <h1 className="mt-2 font-display text-3xl lg:text-5xl font-extrabold tracking-tight">{title}</h1>
          {description && <p className="mt-3 text-slate-400 max-w-2xl">{description}</p>}
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 lg:px-8 py-10">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 lg:p-8">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, name, type = "text", required, ...rest }) {
  return (
    <div>
      <Label className="text-[10px] font-mono uppercase tracking-widest text-slate-500">{label}{required && " *"}</Label>
      <Input data-testid={`field-${name}`} name={name} type={type} required={required} className="mt-1.5" {...rest} />
    </div>
  );
}

export function useFormSubmit(endpoint) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (payload, api) => {
    setLoading(true);
    try {
      await api.post(endpoint, payload);
      setDone(true);
      toast.success("Request received — we'll be in touch shortly.");
    } catch (e) {
      toast.error("Could not submit. " + (e?.response?.data?.detail || ""));
    } finally { setLoading(false); }
  };
  return { loading, done, submit };
}

export function Success({ message }) {
  return (
    <div data-testid="form-success" className="text-center py-8">
      <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
      <div className="mt-4 font-heading text-xl font-semibold text-slate-900">Thanks — request received</div>
      <p className="text-slate-500 mt-2 max-w-md mx-auto">{message}</p>
    </div>
  );
}
